import React from 'react';

const GetTheLook = () => {
  const images = [
    "https://images.pexels.com/photos/1926769/pexels-photo-1926769.jpeg?auto=compress&cs=tinysrgb&w=300",
    "https://images.pexels.com/photos/1040945/pexels-photo-1040945.jpeg?auto=compress&cs=tinysrgb&w=300",
    "https://images.pexels.com/photos/1082529/pexels-photo-1082529.jpeg?auto=compress&cs=tinysrgb&w=300",
    "https://images.pexels.com/photos/1183266/pexels-photo-1183266.jpeg?auto=compress&cs=tinysrgb&w=300",
    "https://images.pexels.com/photos/2872767/pexels-photo-2872767.jpeg?auto=compress&cs=tinysrgb&w=300"
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-2">Get the Look</h2>
        <p className="text-gray-600">From cool Hoodies price to comfort. All fashion more info.</p>
      </div>

      <div className="flex overflow-x-auto space-x-6 pb-4 scrollbar-hide">
        {images.map((image, index) => (
          <div key={index} className="flex-shrink-0">
            <img
              src={image}
              alt={`Look ${index + 1}`}
              className="w-64 h-80 object-cover rounded-lg"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default GetTheLook;
